import { ApolloCache } from 'apollo-cache';
import { merge } from 'lodash';
import {
    AthleteOptions,
    CustomStreamType,
    StravaResolution,
    StravaStreamType,
    UnitsPreference
} from '../../components/Strava/types';
import { DemoAthleteQuery } from './queries';

/** Default athlete settings for the demonstation data */
export const defaults = {
    demoAthlete: {
        __typename: 'DemoAthlete',
        activityStreamTypes: [StravaStreamType.altitude, CustomStreamType.pace],
        autoplayAnimation: true,
        id: 'demoathlete',
        resolution: StravaResolution.medium,
        selectedActivityStreamType: StravaStreamType.altitude,
        unitsPreference: UnitsPreference.imperial
    }
};

/**
 * Updates the local state with any changed settings.  Settings
 * are not persisted after page refresh to avoid any privacy problems
 * from using cookies or local storage
 */
export const updateAthleteOptions = (
    athleteOptions: AthleteOptions,
    cache: ApolloCache<any>
) => {
    const previous: any =
        cache.readQuery<any>({
            query: DemoAthleteQuery
        }) || {};

    const data = {
        __typename: 'DemoAthletePayload',
        demoAthlete: {
            __typename: 'DemoAthlete',
            ...merge(previous, athleteOptions),
            id: 'demoathlete'
        }
    };

    cache.writeData({ data });
    return data;
};



// WEBPACK FOOTER //
// ./src/client/clientState/demoAthlete/services.ts